import { Trash2 } from 'blaze-ui/icons'
import Styles from './FileItem.module.scss'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Video } from 'blaze-ui/icons/24'
import { Voice } from 'blaze-ui/icons/16'

export const FileItem = ({ file, onRemove, type }: { file: File; onRemove: () => void; type: 'audio' | 'video' }) => {
  return (
    <div className={Styles.fileItem}>
      {type === 'audio' ? <Voice size={20} /> : <Video />}
      <div className={Styles.fileItemDetails}>
        <div>{file.name}</div>
        <IconButton icon={Trash2} onPress={onRemove} variant="editor" />
      </div>
    </div>
  )
}
